import { Link } from "react-router-dom";
import { Heart, Eye } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";
import { formatPrice } from "@/data/products";

export default function ProductCard({ product, priority = false }) {
  const { has, toggle } = useWishlist();
  const { add } = useCart();
  const active = has(product.id);
  const alt = product.images?.[1] || product.images?.[0];

  return (
    <div className="group" data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="block relative overflow-hidden bg-muted aspect-[3/4]">
        {product.images?.[0] && (
          <img src={product.images[0]} alt={product.title} loading={priority ? "eager" : "lazy"} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 group-hover:opacity-0" />
        )}
        {alt && (
          <img src={alt} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700 ease-out group-hover:opacity-100" />
        )}
        {product.tag && (
          <div
            className="absolute -top-1 -left-1 w-24 h-24 overflow-hidden pointer-events-none z-10"
            data-testid={`ribbon-${product.slug}`}
            aria-hidden="true"
          >
            <span
              className="absolute top-[18px] -left-[34px] w-[130px] text-center text-[10px] uppercase tracking-[0.2em] font-medium py-1 text-ivory bg-[#B0000F] shadow-[0_2px_4px_rgba(0,0,0,0.15)] -rotate-45 select-none"
              style={{ letterSpacing: "0.18em" }}
            >
              {product.tag}
            </span>
          </div>
        )}
        <button
          data-testid={`wishlist-toggle-${product.slug}`}
          onClick={(e) => { e.preventDefault(); toggle(product); }}
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-ivory/85 backdrop-blur-sm hover:bg-ivory transition-colors"
          aria-label="Wishlist"
        >
          <Heart size={15} strokeWidth={1} fill={active ? "#0A0A0A" : "none"} />
        </button>
        <div className="absolute inset-x-4 bottom-4 flex gap-2 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
          <button
            data-testid={`quick-add-${product.slug}`}
            onClick={(e) => { e.preventDefault(); add(product, product.sizes?.[0] || "", product.colors?.[0] || "", 1); }}
            className="flex-1 uppercase tracking-[0.2em] text-[10px] font-medium bg-ink text-ivory py-3 hover:bg-ivory hover:text-ink border border-ink transition-colors duration-500"
          >Add To Bag</button>
          <Link
            to={`/product/${product.slug}`}
            className="w-11 h-11 flex items-center justify-center bg-ivory border border-ink hover:bg-ink hover:text-ivory transition-colors"
            onClick={(e) => e.stopPropagation()}
            aria-label="Quick view"
          ><Eye size={14} strokeWidth={1} /></Link>
        </div>
      </Link>
      <div className="mt-4 space-y-1">
        <Link to={`/product/${product.slug}`} className="font-serif text-lg tracking-tight leading-tight hover:italic">{product.title}</Link>
        <p className="text-xs text-muted-foreground">{product.subtitle}</p>
        <p className="text-sm mt-2" data-testid={`product-price-${product.slug}`}>{formatPrice(product.price)}</p>
      </div>
    </div>
  );
}
